import { CARDAPIO_DIAS_TOLERANCIA } from '../../config/cardapio';
import type { RestauranteCardapio } from '../../types/cardapio';

export interface ResultadoLicenca {
  ok: boolean;
  msg: string;
  diasRestantes?: number;
}

/** Verifica se o restaurante pode usar o cardápio (mensalidade + ativo). */
export function verificarLicenca(r: RestauranteCardapio): ResultadoLicenca {
  if (!r.ativo) {
    return { ok: false, msg: 'Serviço suspenso pelo administrador. Entre em contato para reativar.' };
  }
  if (!r.pagoAte || !/^\d{4}-\d{2}-\d{2}$/.test(r.pagoAte)) {
    return { ok: false, msg: 'Licença não configurada. Contate o administrador do sistema.' };
  }
  const fim = new Date(r.pagoAte + 'T23:59:59');
  const limite = fim.getTime() + CARDAPIO_DIAS_TOLERANCIA * 24 * 60 * 60 * 1000;
  const agora = Date.now();
  const diasRestantes = Math.ceil((fim.getTime() - agora) / (24 * 60 * 60 * 1000));
  if (agora > limite) {
    return {
      ok: false,
      msg: `Mensalidade em atraso (venceu em ${formatarDataBr(r.pagoAte)}). Renove para continuar.`,
    };
  }
  return {
    ok: true,
    msg: diasRestantes <= 5 ? `Licença válida — renova em ${diasRestantes} dia(s).` : 'Licença ativa.',
    diasRestantes,
  };
}

function formatarDataBr(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}
